import { render, staticRenderFns } from "./ColdChainEditor.vue?vue&type=template&id=341b3d1f"
import script from "./ColdChainEditor.vue?vue&type=script&lang=js"
export * from "./ColdChainEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports